module.exports = __webpack_public_path__ + "svgs/arrowheadDiagonalRight.6b64104dc35b43bdfd9a6a5df5f251b5.svg";